<template>
   <div class="useList">
        <div class="useBox" v-for="(item,index) in useData" :key="index" @click="useBoxTap(item)">
            <div class="useTitle">{{ item.title }}</div>
            <div class="useTips">{{ item.tips }}</div>
            <div class="useNum">{{ item.num }}人已用</div>
            <div class="useBtn">免费试用</div>
            <el-image :src="item.img" fit="cover" class="useImg"></el-image>
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return {

            }
        },
        props:{
			useData: {
				type: Array,
				default: () => []
			},
		},
        methods: {
             // 视频号功能跳转
            useBoxTap(e){
                if(e.url != ''){
                    if(e.type){
                        this.$router.push({ path:e.url, query:{type:e.type,name:e.title} })
                    }else{
                        this.$router.push({ path:e.url })
                    }
                }
            },
        }
    }
</script>
<style lang="less" scoped>
.useList{
        width: 1164px;
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 10px;
        .useBox{
            width: 253px;
            height: 179px;
            padding-left: 30px;
            border: 1px solid #EBEDF1;
            box-shadow: 0px 0px 27px 0px rgba(124,124,124,0.11);
            border-radius: 8px;
            margin: 24px 8px 0 0;
            position: relative;
            // &:nth-child(1){
            //     background: #FAFAFA url(../assets/icon/nav01.png) no-repeat right bottom/136px 132px;
            // }
            // &:nth-child(2){
            //     background: #FAFAFA url(../assets/icon/nav02.png) no-repeat right bottom/136px 132px;
            // }
            // &:nth-child(3){
            //     background: #FAFAFA url(../assets/icon/nav03.png) no-repeat right bottom/136px 132px;
            // }
            // &:nth-child(4){
            //     background: #FAFAFA url(../assets/icon/nav04.png) no-repeat right bottom/136px 132px;
            // }
            // &:nth-child(5){
            //     background: #FAFAFA url(../assets/icon/nav05.png) no-repeat right bottom/136px 132px;
            // }
            // &:nth-child(6){
            //     background: #FAFAFA url(../assets/icon/nav06.png) no-repeat right bottom/136px 132px;
            // }
            // &:nth-child(7){
            //     background: #FAFAFA url(../assets/icon/nav07.png) no-repeat right bottom/136px 132px;
            // }
            &:nth-child(4n){
                margin-right: 0;
            }
            .useTitle{
                font: 20px/20px "Microsoft YaHei";
                margin-top: 26px;
            }
            .useTips{
                font: 16px/16px "Microsoft YaHei";
                color: #FF6A00;
                margin-top: 14px;
            }
            .useNum{
                font: 12px/12px "Microsoft YaHei";
                color: #A4A4A4;
                margin-top: 10px;
            }
            .useBtn{
                width: 90px;
                height: 34px;
                border: 1px solid #FF6A00;
                border-radius: 18px;
                font: 14px/34px "Microsoft YaHei";
                color: #FF6A00;
                text-align: center;
                cursor: pointer;
                margin-top: 29px;
                &:hover{
                    background: #FF6A00;
                    color: #fff !important;
                }
            }
            .useImg{
                width: 136px;
                height: 132px;
                position: absolute;
                right: 0;
                bottom: 0;
            }
        }
    }
</style>